import React, { FC, useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import DataGrid, { Column, FilterRow, Paging, Scrolling, Selection } from 'devextreme-react/data-grid';

import { AppFieldBox } from 'components/appComponents';
import { DropDownBox } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

type TrasportProps = {
  value: number | null;
  readOnly: boolean;
  onChange?: (value: number | null) => void;
};

const gridBoxDisplayExpr = (item: { fullName: string }) => item && `${item.fullName}`;

const Transport: FC<TrasportProps> = ({ value, readOnly, onChange }) => {
  let { id } = useParams<{ id: string }>();
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);

  const storeTransport: any = useMemo(() => {
    return $createStore('/v1/Transport', 'id', {
      defaultFilter: [['transportType', '=', 0], 'and', ['id', '>=', 0]],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const storeTransportSelect: any = useMemo(() => {
    return $createStore('/v1/Transport', 'id');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const dataGridOnSelectionChanged = React.useCallback((e: any) => {
    e.selectedRowKeys.length && onChange && onChange(e.selectedRowKeys[0]);
    setIsGridBoxOpened(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dataGridRender = React.useCallback(
    () => (
      <DataGrid
        dataSource={storeTransport}
        hoverStateEnabled={true}
        showBorders={true}
        selectedRowKeys={[value]}
        onSelectionChanged={dataGridOnSelectionChanged}
        height="100%"
      >
        <Selection mode="single" />
        <Scrolling mode="virtual" />
        <Paging enabled={true} pageSize={100} />
        <FilterRow visible={true} />
        <Column dataField="contractor" caption="Контрагент" />
        <Column dataField="fullName" caption="Полное наименование" />
        <Column dataField="customName" caption="Доп. наименование" />
        <Column dataField="quantity" caption="Объём / Метраж" />
      </DataGrid>
    ),
    [storeTransport, value, dataGridOnSelectionChanged],
  );

  const syncDataGridSelection = useCallback(
    (e) => {
      onChange && onChange(e.id);
    },
    [onChange],
  );

  const onGridBoxOpened = useCallback((e) => {
    if (e.name === 'opened') {
      setIsGridBoxOpened(e.value);
    }
  }, []);

  return (
    <AppFieldBox label="Транспорт" labelTop>
      <DropDownBox
        stylingMode="underlined"
        value={value}
        opened={isGridBoxOpened}
        valueExpr="id"
        deferRendering={false}
        displayExpr={gridBoxDisplayExpr}
        placeholder="Выберете транспорт"
        dataSource={storeTransportSelect}
        readOnly={readOnly}
        onChange={syncDataGridSelection}
        //onValueChanged={syncDataGridSelection}
        onOptionChanged={onGridBoxOpened}
        contentRender={dataGridRender}
        dropDownOptions={{
          width: 600,
        }}
        buttons={[
          'dropDown',
          {
            name: 'cleare',
            location: 'after',
            options: {
              onClick: () => onChange?.(null),
              icon: 'close',
            },
          },
        ]}
      />
    </AppFieldBox>
  );
};

export default Transport;
